import React from "react";

function AtelierGrid({ ateliers, selectedSession }) {
  return (
    <>
      { selectedSession && selectedSession.description != null &&
        <div className="row justify-content-center p-4">
          <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-3">
            <p>{selectedSession.description}</p>
          </div>
        </div>
      }

      <div className="row">
        {ateliers.map((atelier) => (
          <div key={atelier.Id} className="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
              {atelier.image?.[0]?.signedUrl && (
                <img
                  src={atelier.image?.[0]?.signedUrl}
                  alt={atelier.title}
                  style={{ width: "100%" }}
                />
              )}
              <p className="fw-bold mt-1">{atelier.title}</p>
            </div>
        ))}
      </div>
    </>
  );
}

export default AtelierGrid;
